import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';
import { ExpenseStatusValuesEnum } from './ExpenseStatus.enum';

const MiscExpenseDescription = (props) => {
    const { index, expense, isMiscExpense, isViewOnly } = props;
    const { control, watch, errors } = useFormContext();

    return (
        <Grid item xs={12}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].miscDescription`}
                defaultValue={expense.miscDescription}
                isViewOnly={isViewOnly}
                rules={{
                    required:
                        expense?.status !== ExpenseStatusValuesEnum.NonReimbursable &&
                        expense?.status !== ExpenseStatusValuesEnum.Abandoned &&
                        isMiscExpense
                            ? 'Misc. Description is required for a misc. expense'
                            : false,
                }}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        required={
                            expense?.status !== ExpenseStatusValuesEnum.NonReimbursable &&
                            expense?.status !== ExpenseStatusValuesEnum.Abandoned &&
                            isMiscExpense
                        }
                        multiline
                        inputProps={{ maxLength: 20 }}
                        minRows={1}
                        id={`miscDescription${index}`}
                        onChange={onChange}
                        value={value}
                        label="Misc. Description"
                        error={Boolean(errors.expenseEntries?.[index]?.miscDescription)}
                        disabled={!isMiscExpense || isViewOnly}
                        helperText={
                            errors.expenseEntries?.[index]?.miscDescription?.message
                                ? errors.expenseEntries?.[index]?.miscDescription?.message
                                : value && `${value.length}/20`
                        }
                        placeholder="Enter misc. description"
                        slotProps={{
                            input: {
                                sx: {
                                    height: 'auto',
                                    fontSize: '14px',
                                    padding: '10px 12px !important',
                                },
                            },
                        }}
                        isViewOnly={isViewOnly}
                        sx={{
                            '& .MuiInputBase-root': {
                                marginTop: '0',
                            },
                            '& .MuiInputLabel-shrink': {
                                transform: 'translate(0, 1.5px) scale(0.75) !important',
                            },
                            '& .MuiInputBase-root::before': { borderBottom: 'none !important' },
                            '& .MuiInputBase-root::after': { borderBottom: 'none !important' },
                        }}
                    />
                )}
            />
        </Grid>
    );
};

export default MiscExpenseDescription;
